<template>
  <div v-if="selectedConfig" :style="{ backgroundColor: selectedConfig.color.concat('80')}">
    <div
      v-if="!selectedConfig.blocked && selectedConfig.allowCustomEvents"
      style="padding: 5px 0 0 5px;"
    >
          <v-btn 
            @click="view = 'schedule'"
            style="margin-right: 10px;"
            :color="view === 'schedule' ? selectedConfig.color : null"
            :dark="view === 'schedule' ? selectedConfig.dark : false"
            :large="view === 'schedule'"
          >
            <span 
              class="hidden-sm-and-down"
              :style="{color: view === 'schedule' ? selectedConfig.dark ? 'white' : 'black' : 'black'}"
            >Programaci�n</span>

            <v-icon right>
              mdi-calendar-plus
            </v-icon>
          </v-btn>
          <v-btn 
            v-if="(!selectedConfig.blocked && selectedConfig.allowCustomEvents) && (selectedConfig.id==='pro' || selectedConfig.id==='live-stage' || !checkIsSpring)"
            @click="view = 'manager'"
            :color="view === 'manager' ? selectedConfig.color : null"
            :dark="view === 'manager' ? selectedConfig.dark : false"
            :large="view === 'manager'"
            style="margin-right: 10px;"
          >
            <span 
              class="hidden-sm-and-down"
              :style="{color: view === 'manager' ? selectedConfig.dark ? 'white' : 'black' : 'black'}"
        >Crea tu evento propio</span>

            <v-icon right>
              mdi-ticket
            </v-icon>
          </v-btn>
    </div>
    <!--div
      v-if="selectedConfig.blocked"
      style="padding: 100px"
    >
      <center>
      <h1>No disponible</h1>
      </center>
    </div-->
    <schedule
      v-if="view === 'schedule'"
      :key="`${contentTypeID}-${contentType}`"
      :contentTypeID="contentTypeID"
      :isPaxCount="isPaxCount"
      :planID="contentType"
      :locale="locale"
      :config="config.filter(x => x.id===contentType).shift()"
    />
    <custom-manager
      v-if="!selectedConfig.blocked && view === 'manager'"
      :key="`manager-${contentTypeID}-${contentType}`"
      :contentTypeID="contentTypeID"
      :planID="contentType"
      :locale="locale"
      :config="config"
      :selectedPlan="config.filter(x => x.id===contentType).shift()"
    />

    <!--div 
      v-else-if="view === 'manager'"
      style="padding: 100px; text-align: center;min-height: calc(100vh);"
    >
      <h1> TODO: pendiente de hacer </h1>
    </div-->
  </div>
</template>
<script>
import { mapState } from 'vuex'
import api from '@/services/api'
import utilsService from '@/services/utils'
import Schedule from './Schedule'
import CustomManager from './customManager/Index'
export default {
  components: {
    Schedule,
    CustomManager,
  },
  data: () => ({
    isPaxCount: false,
    view: null,
    config: null,
    selectedConfig: null,
    contentTypeID: null,
    contentType: null,
  }),
  computed: {
    ...mapState('app',['locale']),
    userID () {
      return utilsService.getUser()
    },
    checkIsSpring () {
      const aux = new Date().toISOString().split('T').shift()
      return aux >= '2026-04-10' ? true : false
    },
  },
  watch: {
    '$route.params.id' () {
      this.init()
    },
    '$route.params.type' () {
      this.init()
    },
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.view = 'schedule'
      this.contentTypeID = this.$route.params.id
      this.contentType = this.$route.params.type
      this.handleGetConfig()
    },
    async handleGetConfig () {
      try {
        this.isPaxCount = await new Promise((resolve) => api.getAllWithoutLimit('system', `v1/internal/users/${this.userID}/activity-barcelo-01-permissions-pax-count`)
          .then(response => {
            resolve(response && response.filter(x => x !== null).length > 0 ? true : false)
          })
          .catch(error => {
            console.log(error)
            resolve(false)
          }))
        this.config = null
        this.selectedConfig = null
        api.getAll('dviewcontent', `v1/private/activity-barcelo-01/config/${this.contentTypeID}`)
          .then((response) => {
            this.config = response
            this.selectedConfig = this.config ? this.config.filter(x => x.id === this.contentType).shift() : null
          })
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>

